export const upperCaseFirst = (input: string): string =>
  input ? input.charAt(0).toUpperCase() + input.slice(1) : input
